import React, { Component } from "react";
import Child from "./Child.js";
import styled from 'styled-components';
import classes from "./Parent.module.css";


const AppName = styled.h1`
  width: 100%;
  font-size: 100px;
  font-weight: 100;
  text-align: center;
  color: rgba(175, 47, 47, 0.15);
`;

const Container = styled.div`
`;

const AppContainer = styled.div`
background-color: white`;

const Header = styled.div`
border-bottom: 1px solid #ededed;;
display: flex;
align-items: center;`;

const ChooseAll = styled.button`
  visibility: ${props => props.visible > 0 ? 'visible' : 'hidden'};
  border: none;
  background-color: transparent;
  transform: rotate(90deg);
  width: 60px;
  font-size: 0;
  transform: rotate(90deg);
  font-size: 22px;
  color: ${props => props.allChecked ? '#737373' : '#e6e6e6'};
    padding: 10px 27px 10px 27px;
`;

const NewTask = styled.input`
  padding: 16px 16px 16px 60px;
  border: none;
  background: rgba(0, 0, 0, 0.003);
  box-shadow: inset 0 -2px 1px rgba(0,0,0,0.03);
  font-size: 24px;
  ::placeholder {
    color: "red";
  }
`;

const FilterButton = styled.button`
  background-color: transparent;
  margin: 3px;
  padding: 3px 7px;
  color: rgb(119, 119, 119);
  border-radius: 3px;
  border: 1px solid transparent;
  border-color: ${props => (props.active ? 'rgba(175, 47, 47, 0.2)' : 'transparent')};
`;


class Parent extends Component {
  constructor(props) {
    super(props);
    this.inputLink = React.createRef();
  }

  state = {
    inputs: [],
    menu: {
      all: true,
      active: false,
      completed: false,
    },
    mode: "all",
    selected: false
  };

  componentDidUpdate(prevProps) {
    const inputs = [...this.state.inputs];

    inputs.forEach(input => {
      if (input.disabled === false) {
        this.inputLink.current.focus();
      }
    });
  }

  onKeyDownHandler = e => {
    if (e.target.id === "parent" && e.key === "Enter") {
      const prevState = [...this.state.inputs];

      let lastId, nextId;
      if (prevState.length !== 0) {
        lastId = prevState[prevState.length - 1].id || 1;
        nextId = lastId + 1;
      } else {
        nextId = 1;
      }

      prevState.push({
        disabled: true,
        content: e.target.value,
        id: nextId,
        deleted: false,
        checked: false
      });

      const newState = {
        ...this.state,
        inputs: prevState
      };

      this.setState(newState);
      e.target.value = "";
    }
  };

  onClickHandler = e => {
    if (
      e.target.nodeName === "INPUT" &&
      e.target.id !== "parent" &&
      e.target.type === "text"
    ) {
      const content = e.target.value;
      let index = null;

      const prevState = [...this.state.inputs];
      prevState.forEach((input, i) => {
        if (input.content === content) {
          index = i;
        }
      });

      prevState[index].disabled = false;

      const newState = {
        ...this.state,
        inputs: prevState
      };

      this.setState(newState);
    }
  };

  onBlurHandler = e => {
    if (
      e.target.nodeName === "INPUT" &&
      e.target.id !== "parent" &&
      e.target.type === "text"
    ) {
      const id = e.target.id;

      const prevState = [...this.state.inputs];
      prevState.forEach(input => {
        if (input.id === Number(id)) {
          input.disabled = true;
        }
      });

      const newState = {
        ...this.state,
        inputs: prevState
      };

      this.setState(newState);
    }

  };

  onChangeHandler = e => {
    const index = e.target.id - 1;
    const prevState = [...this.state.inputs];

    prevState[index].content = e.target.value;

    const newState = {
      ...this.state,
      inputs: prevState
    };

    this.setState(newState);
  };

  onCheckHandler = e => {
    const id = e.target.parentNode.nextElementSibling.id;
    const prevState = [...this.state.inputs];

    prevState.forEach(input => {
      if (input.id === Number(id)) {
        input.checked = e.target.checked;
      }
    });

    const newState = {
      ...this.state,
      inputs: prevState
    };

    this.setState(newState);
  };

  onDeleteButtonClickHandler = e => {
    const id = e.target.previousElementSibling.id;

    const prevState = [...this.state.inputs];

    let index = null;
    prevState.forEach((input, i) => {
      if (input.id === Number(id)) {
        index = i;
      }
    });

    if (index !== null) {
      // prevState[index].deleted = true;
      prevState.splice(index, 1);
    }

    const newState = {
      ...this.state,
      inputs: prevState
    };

    this.setState(newState);
  };

  onShowAllHandler = e => {
    let { mode } = this.state;
    const newState = {
      ...this.state,
      menu: { 
        ...this.state.mode,
        [mode]: false,
        all: true,
      },
      mode: 'all',
    };
    
    this.setState(newState);
  };

  onShowActiveHandler = e => {
    let { mode } = this.state;
    const newState = {
      ...this.state,
      menu: { 
        ...this.state.mode,
        [mode]: false,
        active: true,
      },
      mode: 'active',
    };
    
    

    this.setState(newState);
  };

  onShowCompletedHandler = e => {

    let { mode } = this.state;
    const newState = {
      ...this.state,
      menu: { 
        ...this.state.mode,
        [mode]: false,
        completed: true,
      },
      mode: 'completed',
    };
    
    this.setState(newState);
  };

  onDeleteSelected = e => {
    const prevState = [...this.state.inputs];

    //  let prevDeleted = false;
    for (let i = 0; i < prevState.length; i = i + 1) {
      if (prevState[i].checked === true) {
        prevState.splice(i, 1);
        i = i - 1;
        // prevDeleted = true;
        // prevState[i].deleted = true;
      }
    }

    const newState = {
      ...this.state,
      inputs: prevState
    };

    this.setState(newState);
  };

  onToggleAllHandler = e => {
    let { selected } = this.state;
    const prevState = [...this.state.inputs];
    prevState.forEach(input => {
      if (!selected) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    });

    const newState = {
      ...this.state,
      inputs: prevState,
      selected: !selected
    };

    this.setState(newState);
  };



  render() {

    const mode = this.state.mode;
    let somethingSelected = null;
    let checked = 0;
    let allChecked = true;
    const inputs = this.state.inputs.map((input, index) => {
      if (input.checked === true) {
        somethingSelected = true;
      } else {
        allChecked = false;
        checked = checked + 1;
      }
      let child;
      if (!input.deleted) {
        child = (
          <Child
            key={input.id}
            change={this.onChangeHandler}
            check={this.onCheckHandler}
            click={this.onClickHandler}
            delete={this.onDeleteButtonClickHandler}
            disabled={input.disabled ? true : false}
            content={input.content}
            id={this.state.inputs[index].id}
            checked={this.state.inputs[index].checked}
          />
        );

        if (input.disabled === false) {
          child = (
            <Child
              key={input.id}
              change={this.onChangeHandler}
              check={this.onCheckHandler}
              click={this.onClickHandler}
              delete={this.onDeleteButtonClickHandler}
              disabled={input.disabled ? true : false}
              content={input.content}
              inputRef={this.inputLink}
              id={this.state.inputs[index].id}
              checked={this.state.inputs[index].checked}
            />
          );
        }

        if (mode === "all") {
          return child;
        } else if (mode === "active" && input.checked === false) {
            return child;
        } else if (mode === "completed" && input.checked === true) {
            return child;
        }
      }
      return null;
    });

    return (
      <Container
        
        className={classes.parent}
        onBlur={this.onBlurHandler}
        onClick={this.onClickHandler}
      >
        <AppName> todos </AppName>


        <AppContainer>
          <Header>

            <ChooseAll visible={this.state.inputs.length} allChecked={allChecked} onClick={this.onToggleAllHandler} type="button">
              {" "}
              ❯ {" "}
            </ChooseAll>
            
            <NewTask
              onKeyDown={this.onKeyDownHandler}
              id="parent"
              type="text"
              placeholder="Что нужно сделать?"
     
            />
          </Header>

        

        {inputs}

        <div className={classes.footer}>
          <FilterButton active={this.state.menu.all} onClick={this.onShowAllHandler} type="button">
            Все
          </FilterButton>
          <FilterButton active={this.state.menu.active} onClick={this.onShowActiveHandler} type="button">
            Активные
          </FilterButton>
          <FilterButton active={this.state.menu.completed} onClick={this.onShowCompletedHandler} type="button">
            {" "}
            Завершенные{" "}
          </FilterButton>
          <FilterButton
            className={somethingSelected ? "" : classes.hide}
            onClick={this.onDeleteSelected}
            type="button"
          >
            {" "}
            Удалить выбранные{" "}
          </FilterButton>
          <p> Осталось {checked} задачи </p>
        </div>

        </AppContainer>
        
      </Container>
    );
  }
}

export default Parent;
